
import { defineComponent } from 'vue'
import ImageBox from '@/components/ImageBox.vue'
import Button from '@/components/AtomButton.vue'
import Config from '@/config/customily'

export default defineComponent({
  components: {
    ImageBox,
    Button
  },
  props: {
    item: {}
  },
  methods: {
    formatDate (date: string):string {
      const DateArr: Array<string> = date.split('T')
      return DateArr[0].split('-').reverse().join('/')
    },
    getImagePath (path: string):string {
      return path.replace(/^\/Content/g, Config.imageBaseUrl)
    },
    getProductPath (name: string, id: string) :string {
      return '/product/' + name.toLowerCase().split(' ').join('-') + '_' + id
    }
  }
})
